import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DynFormsLogicService } from './logic/dyn-forms/dyn-forms-logic.service';
import { DynFormsDaoService } from './dao/dyn-form/dyn-forms-dao.service';
import { DynFormsService } from './logic/dyn-forms.service';
import { DynFormsDbDaoService } from './dao/dyn-form/dyn-forms-dao/dyn-forms-db-dao.service';
import { DynFormDataDaoService } from './dao/dyn-form-data/dyn-form-data-dao.service';
import { DynFormDataDbDaoService } from './dao/dyn-form-data/dyn-form-data-dao/dyn-form-data-db-dao.service';
import { DynFormDbTableDefinition } from './dao/dyn-form/dyn-forms-dao/dyn-form-db-table-definition';
import { DynFormDataDbTableDefinition } from './dao/dyn-form-data/dyn-form-data-dao/dyn-form-data-db-table-definition';

@NgModule({
  declarations: [],
  imports: [CommonModule],
  providers: [
    { provide: DynFormsService, useClass: DynFormsLogicService },
    {
      provide: DynFormsDaoService,
      useClass: DynFormsDbDaoService
    },
    {
      provide: DynFormDataDaoService,
      useClass: DynFormDataDbDaoService
    },
    { provide: DynFormDbTableDefinition },
    { provide: DynFormDataDbTableDefinition },
  ]
})
export class DynFormsModule {}
